import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=619349e2&"
import script from "./back-to-top.vue?vue&type=script&lang=js&"
export * from "./back-to-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports